import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { fromFHIR } from '../../../../lib/Proxy/audit-log'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import MagicGrid from '../../../shared/MagicGrid'
import { CircularProgress } from '../../../shared/NarusMaterial'
import { getAuditLog } from '../actions'

class AuditLog extends React.Component {
  UNSAFE_componentWillMount () {
    const { dispatch, patientId, reportId } = this.props
    dispatch(getAuditLog(patientId, reportId))
  }

  render () {
    const {
      reports: { auditLog, auditLogError, loadingAuditLog }
    } = this.props
    if (loadingAuditLog) {
      return <CircularProgress />
    }

    if (auditLogError) {
      return <div>Error loading audit log for this document.</div>
    }

    if (auditLog) {
      const mappedResponse = auditLog.entry.map(e => fromFHIR(e.resource))
      const cleanMultiSpaces = str => str.replace(/\s+/g, ' ')

      const headers = [
        {
          title: 'Sender',
          displayFn: a => cleanMultiSpaces(_.get(a, 'user', 'Unknown'))
        },
        {
          title: 'Recipient',
          displayFn: a => _.get(a, 'recipient', 'Unknown')
        },
        {
          title: 'Address',
          displayFn: a => _.get(a, 'address', 'Unknown')
        },
        {
          title: 'Type',
          displayFn: a => {
            const type = _.get(a, 'type')
            if (type === 'secureEmail') {
              return 'Email'
            }
            if (type === 'secureFax') {
              return 'Fax'
            }
            return 'Unknown'
          }
        },
        {
          title: 'Outcome',
          displayFn: a => (a.outcome === '0' ? 'Success' : 'Failed')
        },
        {
          title: 'Time',
          displayFn: a => <FriendlyDateTime datetime={a.recorded} />,
          sortBy: 'recorded'
        }
      ]

      return (
        <MagicGrid
          rows={mappedResponse}
          headers={headers}
          canDelete={false}
          disableGrid
          itemName='audit log records'
          sortOn={5}
          sortDir='desc'
        />
      )
    }

    return null
  }
}

AuditLog.propTypes = {
  patientId: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired
}

const mapStateToProps = redux => ({
  reports: redux.reports
})

export default connect(mapStateToProps)(AuditLog)
